import { useStudent } from 'shared/hooks/user/useStudent';

export const useStudentId = () => useStudent()?.id;
